export const RESPIRATORY_NAMES = {
  "Diaphragm": { english: "Diaphragm", latin: "Diaphragma" },
  "Digastiric": { english: "Digastric Muscle", latin: "Musculus Digastricus" },
  "Geniohyoid": { english: "Geniohyoid Muscle", latin: "Musculus Geniohyoideus" },
  "Mylohyoid": { english: "Mylohyoid Muscle", latin: "Musculus Mylohyoideus" },
  "Stylohyoid": { english: "Stylohyoid Muscle", latin: "Musculus Stylohyoideus" },
  "Nasal_cavity": { english: "Nasal Cavity", latin: "Cavitas Nasi" },
  "Nasopharynx": { english: "Nasopharynx", latin: "Pars Nasalis Pharyngis" },
  "Arythenoid_cartilage": { english: "Arytenoid Cartilage", latin: "Cartilago Arytenoidea" },
  "Corniculate_cartilage": { english: "Corniculate Cartilage (Cartilage of Santorini)", latin: "Cartilago Corniculata" },
  "Cricoid_cartilage": { english: "Cricoid Cartilage", latin: "Cartilago Cricoidea" },
  "Cuneiform_cartilage": { english: "Cuneiform Cartilage (Cartilage of Wrisberg)", latin: "Cartilago Cuneiformis" },
  "Diaphragm_002": { english: "Diaphragm (Muscular Part)", latin: "Pars Muscularis Diaphragmatis" },
  "Epiglottic_cartilage": { english: "Epiglottic Cartilage", latin: "Cartilago Epiglottica" },
  "Hyoio_Bone": { english: "Hyoid Bone", latin: "Os Hyoideum" },
  "Left_Bronchus": { english: "Left Main Bronchus", latin: "Bronchus Principalis Sinister" },
  "Left_Lung": { english: "Left Lung", latin: "Pulmo Sinister" },
  "Median_Thyrohyoid": { english: "Median Thyrohyoid Ligament", latin: "Ligamentum Thyrohyoideum Medianum" },
  "Right_Bronchus": { english: "Right Main Bronchus", latin: "Bronchus Principalis Dexter" },
  "Right_Lung": { english: "Right Lung", latin: "Pulmo Dexter" },
  "Thyro-epiglottic_ligament": { english: "Thyroepiglottic Ligament", latin: "Ligamentum Thyroepiglotticum" },
  "Thyrohyoid_membrane": { english: "Thyrohyoid Membrane", latin: "Membrana Thyrohyoidea" },
  "Thyrohyoid_membrane_001": { english: "Thyrohyoid Membrane", latin: "Membrana Thyrohyoidea" },
  "Thyroid_cartilage": { english: "Thyroid Cartilage", latin: "Cartilago Thyroidea" },
  "Trachea": { english: "Trachea", latin: "Trachea" },
  "Circothyroid_membrane_and_ligament": { english: "Cricothyroid Ligament", latin: "Ligamentum Cricothyroideum" },
  "Stylohyoid_ligament_L": { english: "Stylohyoid Ligament — Left", latin: "Ligamentum Stylohyoideum Sinistrum" },
  "Stylohyoid_ligament_R": { english: "Stylohyoid Ligament — Right", latin: "Ligamentum Stylohyoideum Dextrum" }
};

const RESPIRATORY_KEYS = Object.keys(RESPIRATORY_NAMES);

function fuzzyMatch(name) {
  if (!name) return null;
  if (RESPIRATORY_NAMES.hasOwnProperty(name)) return name;

  const normalized = name.trim();
  for (const key of RESPIRATORY_KEYS) {
    if (key.trim() === normalized) return key;
  }

  const lower = normalized.toLowerCase().replace(/\s+/g, ' ');
  for (const key of RESPIRATORY_KEYS) {
    if (key.toLowerCase().replace(/\s+/g, ' ') === lower) return key;
  }

  return null;
}

export function resolveRespiratoryName(mesh) {
  if (!mesh) return null;

  const meshName = mesh.name || '';
  const matName = mesh.material?.name || '';
  const parentName = mesh.parent?.name || '';

  if (meshName) { const match = fuzzyMatch(meshName); if (match) return match; }
  if (matName) { const match = fuzzyMatch(matName); if (match) return match; }
  if (parentName) { const match = fuzzyMatch(parentName); if (match) return match; }

  let ancestor = mesh.parent;
  while (ancestor) {
    if (ancestor.name) { const match = fuzzyMatch(ancestor.name); if (match) return match; }
    ancestor = ancestor.parent;
  }

  if (meshName.length > 0) return meshName;
  if (matName.length > 0) return matName;

  return null;
}

export function getRespiratoryInfo(meshName) {
  if (!meshName) return { english: "Unknown Structure", latin: "Incertum" };

  const matched = fuzzyMatch(meshName);
  if (matched && RESPIRATORY_NAMES[matched]) return RESPIRATORY_NAMES[matched];

  let clean = meshName.replace(/_/g, ' ').replace(/\d+$/, '').trim();
  clean = clean.replace(/\bL\b/g, 'Left').replace(/\bR\b/g, 'Right');
  return { english: clean, latin: clean };
}
